import en404 from './en/404.json';
import enAboutUs from './en/about-us.json';
import enAccessibility from './en/accessibility.json';
import enAccount from './en/account.json';
import enAdvisors from './en/advisors.json';
import enAdvisoryCouncil from './en/advisory-council.json';
import enBlog from './en/blog.json';
import enCareers from './en/careers.json';
import enChart from './en/chart.json';
import enCommon from './en/common.json';
import enCommunity from './en/community.json';
import enContactSupport from './en/contact-support.json';
import enContactUs from './en/contact-us.json';
import enCurrency from './en/currency.json';
import enDeposit from './en/deposit.json';
import enDocuments from './en/documents.json';
import enFooter from './en/footer.json';
import enHowEnWorks from './en/how-en-works.json';
import enHowWorks from './en/how-works.json';
import enInvite from './en/invite.json';
import enLang from './en/lang.json';
import enLiquidation from './en/liquidation.json';
import enLogin from './en/login.json';
import enNotFound from './en/not-found.json';
import enOverview from './en/overview.json';
import enPortfolio from './en/portfolio.json';
import enPricing from './en/pricing.json';
import enReserveCask from './en/reserve-cask.json';
import enRiskTolerance from './en/risk-tolerance.json';
import enSignUpModal from './en/sign-up-modal.json';
import enSupport from './en/support.json';
import enSustainableFuture from './en/sustainable-future.json';
import enTermsConditions from './en/terms-conditions.json';
import enTheVinovestSatisfactionGuarantee from './en/the-vinovest-satisfaction-guarantee.json';
import enTrading from './en/trading.json';
import enTransactions from './en/transactions.json';
import enVinovestHome from './en/vinovest-home.json';
import enVinovestHundredIndex from './en/vinovest-hundred-index.json';
import enWhiskeyVest from './en/whiskey-vest.json';
import enWhyWine from './en/why-wine.json';
import zh_CN404 from './zh_CN/404.json';
import zh_CNAboutUs from './zh_CN/about-us.json';
import zh_CNAccessibility from './zh_CN/accessibility.json';
import zh_CNAccount from './zh_CN/account.json';
import zh_CNAdvisors from './zh_CN/advisors.json';
import zh_CNAdvisoryCouncil from './zh_CN/advisory-council.json';
import zh_CNBlog from './zh_CN/blog.json';
import zh_CNCareers from './zh_CN/careers.json';
import zh_CNChart from './zh_CN/chart.json';
import zh_CNCommon from './zh_CN/common.json';
import zh_CNContactSupport from './zh_CN/contact-support.json';
import zh_CNContactUs from './zh_CN/contact-us.json';
import zh_CNCurrency from './zh_CN/currency.json';
import zh_CNDeposit from './zh_CN/deposit.json';
import zh_CNDocuments from './zh_CN/documents.json';
import zh_CNFooter from './zh_CN/footer.json';
import zh_CNHowWorks from './zh_CN/how-works.json';
import zh_CNHowZh_CNWorks from './zh_CN/how-zh_CN-works.json';
import zh_CNInvite from './zh_CN/invite.json';
import zh_CNLang from './zh_CN/lang.json';
import zh_CNLiquidation from './zh_CN/liquidation.json';
import zh_CNLogin from './zh_CN/login.json';
import zh_CNNotFound from './zh_CN/not-found.json';
import zh_CNOverview from './zh_CN/overview.json';
import zh_CNPortfolio from './zh_CN/portfolio.json';
import zh_CNPricing from './zh_CN/pricing.json';
import zh_CNRiskTolerance from './zh_CN/risk-tolerance.json';
import zh_CNSignUpModal from './zh_CN/sign-up-modal.json';
import zh_CNSupport from './zh_CN/support.json';
import zh_CNSustainableFuture from './zh_CN/sustainable-future.json';
import zh_CNTermsConditions from './zh_CN/terms-conditions.json';
import zh_CNTheVinovestSatisfactionGuarantee from './zh_CN/the-vinovest-satisfaction-guarantee.json';
import zh_CNTransactions from './zh_CN/transactions.json';
import zh_CNVinovestHome from './zh_CN/vinovest-home.json';
import zh_CNVinovestHundredIndex from './zh_CN/vinovest-hundred-index.json';
import zh_CNWhyWine from './zh_CN/why-wine.json';
import zh_TW404 from './zh_TW/404.json';
import zh_TWAboutUs from './zh_TW/about-us.json';
import zh_TWAccessibility from './zh_TW/accessibility.json';
import zh_TWAccount from './zh_TW/account.json';
import zh_TWAdvisors from './zh_TW/advisors.json';
import zh_TWAdvisoryCouncil from './zh_TW/advisory-council.json';
import zh_TWBlog from './zh_TW/blog.json';
import zh_TWCareers from './zh_TW/careers.json';
import zh_TWChart from './zh_TW/chart.json';
import zh_TWCommon from './zh_TW/common.json';
import zh_TWContactSupport from './zh_TW/contact-support.json';
import zh_TWContactUs from './zh_TW/contact-us.json';
import zh_TWCurrency from './zh_TW/currency.json';
import zh_TWDeposit from './zh_TW/deposit.json';
import zh_TWDocuments from './zh_TW/documents.json';
import zh_TWFooter from './zh_TW/footer.json';
import zh_TWHowWorks from './zh_TW/how-works.json';
import zh_TWHowZh_TWWorks from './zh_TW/how-zh_TW-works.json';
import zh_TWInvite from './zh_TW/invite.json';
import zh_TWLang from './zh_TW/lang.json';
import zh_TWLiquidation from './zh_TW/liquidation.json';
import zh_TWLogin from './zh_TW/login.json';
import zh_TWNotFound from './zh_TW/not-found.json';
import zh_TWOverview from './zh_TW/overview.json';
import zh_TWPortfolio from './zh_TW/portfolio.json';
import zh_TWPricing from './zh_TW/pricing.json';
import zh_TWRiskTolerance from './zh_TW/risk-tolerance.json';
import zh_TWSignUpModal from './zh_TW/sign-up-modal.json';
import zh_TWSupport from './zh_TW/support.json';
import zh_TWSustainableFuture from './zh_TW/sustainable-future.json';
import zh_TWTermsConditions from './zh_TW/terms-conditions.json';
import zh_TWTheVinovestSatisfactionGuarantee from './zh_TW/the-vinovest-satisfaction-guarantee.json';
import zh_TWTransactions from './zh_TW/transactions.json';
import zh_TWVinovestHome from './zh_TW/vinovest-home.json';
import zh_TWVinovestHundredIndex from './zh_TW/vinovest-hundred-index.json';
import zh_TWWhyWine from './zh_TW/why-wine.json';
 

export default {
  "en": {
    "404": en404,
    "about-us": enAboutUs,
    "accessibility": enAccessibility,
    "account": enAccount,
    "advisors": enAdvisors,
    "advisory-council": enAdvisoryCouncil,
    "blog": enBlog,
    "careers": enCareers,
    "chart": enChart,
    "common": enCommon,
    "community": enCommunity,
    "contact-support": enContactSupport,
    "contact-us": enContactUs,
    "currency": enCurrency,
    "deposit": enDeposit,
    "documents": enDocuments,
    "footer": enFooter,
    "how-en-works": enHowEnWorks,
    "how-works": enHowWorks,
    "invite": enInvite,
    "lang": enLang,
    "liquidation": enLiquidation,
    "login": enLogin,
    "not-found": enNotFound,
    "overview": enOverview,
    "portfolio": enPortfolio,
    "pricing": enPricing,
    "reserve-cask": enReserveCask,
    "risk-tolerance": enRiskTolerance,
    "sign-up-modal": enSignUpModal,
    "support": enSupport,
    "sustainable-future": enSustainableFuture,
    "terms-conditions": enTermsConditions,
    "the-vinovest-satisfaction-guarantee": enTheVinovestSatisfactionGuarantee,
    "trading": enTrading,
    "transactions": enTransactions,
    "vinovest-home": enVinovestHome,
    "vinovest-hundred-index": enVinovestHundredIndex,
    "whiskey-vest": enWhiskeyVest,
    "why-wine": enWhyWine
  },
  "zh_CN": {
    "404": zh_CN404,
    "about-us": zh_CNAboutUs,
    "accessibility": zh_CNAccessibility,
    "account": zh_CNAccount,
    "advisors": zh_CNAdvisors,
    "advisory-council": zh_CNAdvisoryCouncil,
    "blog": zh_CNBlog,
    "careers": zh_CNCareers,
    "chart": zh_CNChart,
    "common": zh_CNCommon,
    "contact-support": zh_CNContactSupport,
    "contact-us": zh_CNContactUs,
    "currency": zh_CNCurrency,
    "deposit": zh_CNDeposit,
    "documents": zh_CNDocuments,
    "footer": zh_CNFooter,
    "how-works": zh_CNHowWorks,
    "how-zh_CN-works": zh_CNHowZh_CNWorks,
    "invite": zh_CNInvite,
    "lang": zh_CNLang,
    "liquidation": zh_CNLiquidation,
    "login": zh_CNLogin,
    "not-found": zh_CNNotFound,
    "overview": zh_CNOverview,
    "portfolio": zh_CNPortfolio,
    "pricing": zh_CNPricing,
    "risk-tolerance": zh_CNRiskTolerance,
    "sign-up-modal": zh_CNSignUpModal,
    "support": zh_CNSupport,
    "sustainable-future": zh_CNSustainableFuture,
    "terms-conditions": zh_CNTermsConditions,
    "the-vinovest-satisfaction-guarantee": zh_CNTheVinovestSatisfactionGuarantee,
    "transactions": zh_CNTransactions,
    "vinovest-home": zh_CNVinovestHome,
    "vinovest-hundred-index": zh_CNVinovestHundredIndex,
    "why-wine": zh_CNWhyWine
  },
  "zh_TW": {
    "404": zh_TW404,
    "about-us": zh_TWAboutUs,
    "accessibility": zh_TWAccessibility,
    "account": zh_TWAccount,
    "advisors": zh_TWAdvisors,
    "advisory-council": zh_TWAdvisoryCouncil,
    "blog": zh_TWBlog,
    "careers": zh_TWCareers,
    "chart": zh_TWChart,
    "common": zh_TWCommon,
    "contact-support": zh_TWContactSupport,
    "contact-us": zh_TWContactUs,
    "currency": zh_TWCurrency,
    "deposit": zh_TWDeposit,
    "documents": zh_TWDocuments,
    "footer": zh_TWFooter,
    "how-works": zh_TWHowWorks,
    "how-zh_TW-works": zh_TWHowZh_TWWorks,
    "invite": zh_TWInvite,
    "lang": zh_TWLang,
    "liquidation": zh_TWLiquidation,
    "login": zh_TWLogin,
    "not-found": zh_TWNotFound,
    "overview": zh_TWOverview,
    "portfolio": zh_TWPortfolio,
    "pricing": zh_TWPricing,
    "risk-tolerance": zh_TWRiskTolerance,
    "sign-up-modal": zh_TWSignUpModal,
    "support": zh_TWSupport,
    "sustainable-future": zh_TWSustainableFuture,
    "terms-conditions": zh_TWTermsConditions,
    "the-vinovest-satisfaction-guarantee": zh_TWTheVinovestSatisfactionGuarantee,
    "transactions": zh_TWTransactions,
    "vinovest-home": zh_TWVinovestHome,
    "vinovest-hundred-index": zh_TWVinovestHundredIndex,
    "why-wine": zh_TWWhyWine
  }
}